import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  banner: undefined,
  offers: undefined,
  postOfferAction: undefined,
  getBanner: undefined,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
